module.exports = __webpack_public_path__ + "static/media/project-background.4bf3434d.jpg";